import React, {Component} from 'react';
import {connect} from "react-redux";
import {Accordion, Checkbox, Container, Divider, Grid, Header, Icon} from "semantic-ui-react";
import SelecteurProduitsLayout from "../layouts/SelecteurProduitsLayout";
import {addProduit, removeProduit} from "../actions/panier";
import {ProduitPanier} from "../domain/ProduitPanier";

class SelecteurProduits extends Component {

  constructor(props) {
    super(props);
    this.state = {
      activeIndex: [0, 1, 2, 3, 4, 5, 6, 7]
    };
  }

  handleAccordionTitleClick = (e, titleProps) => {
    const { index } = titleProps;
    const { activeIndex } = this.state;
    if (activeIndex.includes(index)) {
      this.setState({ activeIndex: activeIndex.filter(v => v !== index) });
    } else {
      this.setState({ activeIndex: activeIndex.concat([index]) });
    }
  };

  accordeonProduit = (index, pdt) => (
      <Accordion.Accordion key={index} exclusive={false}>
        <Accordion.Title active={this.state.activeIndex.includes(index)} index={index} onClick={this.handleAccordionTitleClick}>
          <Grid>
            <Grid.Row color={'teal'} verticalAlign={'middle'} textAlign='center'>
              <Grid.Column width={4} textAlign='left'>
                <Header as={'h3'}>
                  <Icon name='dropdown' />{pdt.libelle}
                </Header>
              </Grid.Column>
              {this.props.semainesVisibles.map(
                  (s, idx) => <Grid.Column key={idx} width={2}><Header as={'h3'}>{'S' + s.numero}</Header></Grid.Column>
              )}
            </Grid.Row>
          </Grid>
        </Accordion.Title>
        <Accordion.Content active={this.state.activeIndex.includes(index)}>
          {pdt.pressions.map((pression, idx) => this.produitPression(pdt, pression, idx))}
        </Accordion.Content>
      </Accordion.Accordion>
  );

  produitPression = (pdt, pression, idx) => (
      <Container key={idx} fluid>
        <Divider/>
        <Grid>
          <Grid.Row verticalAlign={'middle'} textAlign='center'>
            <Grid.Column width={2}>
              { pdt.isPressionsMultiples() ? <Header as={'h3'}>Pression {pression}</Header> : null}
            </Grid.Column>
            <Grid.Column width={2}>
              <Header as={'h4'}>&nbsp;</Header>
              <Header as={'h4'}>{pdt.audienceLibelle}</Header>
              <Header as={'h4'}>Tarif</Header>
            </Grid.Column>
            {this.props.semainesVisibles.map((s, idx) => this.produitSemaine(pdt, s, pression, idx))}
          </Grid.Row>
        </Grid>
        <Divider/>
      </Container>
  );

  produitSemaine = (produit, semaine, pression, idx) => {

    const produitPanier = new ProduitPanier(produit, semaine, pression);

    const inPanier = this.props.panier.findIndex(v => v.equals(produitPanier)) >= 0;

    return (
        <Grid.Column key={idx} width={2}>
          <Header as={'h4'}>
            <Checkbox
                checked={inPanier}
                onChange={() => inPanier ? this.props.removeProduit(produitPanier) : this.props.addProduit(produitPanier)}
                disabled={
                  (!produitPanier.produit.isDisponible(produitPanier.semaine)) ||
                    (!inPanier &&
                        this.props.semainesOccupees.findIndex(v => v.code === produitPanier.semaine.code) >= 0
                    )
                }
            />
          </Header>
          <Header as={'h4'} disabled={!inPanier}>{produitPanier.audience().formatFr()}</Header>
          <Header as={'h4'} disabled={!inPanier}>{produitPanier.tarif(this.props.formatSpot).formatEuros()}</Header>
        </Grid.Column>
    );
  };

  render() {
    let pdts = [];

    for (let index = 0; index < this.props.produits.length; index++) {
      pdts.push(this.accordeonProduit(index, this.props.produits[index]));
    }

    return (
        <SelecteurProduitsLayout>
          <Accordion>
            {pdts}
          </Accordion>
        </SelecteurProduitsLayout>
    );
  }
}

const mapStateToProps = (state) => ({
  semainesVisibles: state.navigation.semainesVisibles,
  formatSpot: state.panier.formatSpot,
  panier: state.panier.panier,
  semainesOccupees: state.panier.semainesOccupees
});

const mapDispatchToProps = (dispatch) => ({
  addProduit: (produitPanier) => dispatch(addProduit(produitPanier)),
  removeProduit: (produitPanier) => dispatch(removeProduit(produitPanier))
});

export default connect(mapStateToProps, mapDispatchToProps)(SelecteurProduits);
